import React from 'react';
import styles from './StatusIndicator.module.css';
import { AlarmSeverity } from 'model';
import classnames from 'classnames';
import { FloComponentProps } from 'components';

interface StatusIndicatorProps extends FloComponentProps {
  severity: AlarmSeverity
}

export const StatusIndicator: React.FC<StatusIndicatorProps> = ({severity, className}) => (
  <div className={classnames(
    styles.statusIndicator,
    className,
    { [styles.warning]: severity === AlarmSeverity.WARNING },
    { [styles.critical]: severity === AlarmSeverity.CRITICAL },
    { [styles.info]: severity === AlarmSeverity.INFO },
  )}>
  </div>
)